
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/20 via-accent/10 to-secondary">
      <div className="container max-w-4xl mx-auto py-12 px-4">
        <div className="mb-8">
          <Button 
            variant="ghost" 
            className="flex items-center gap-2" 
            asChild
          >
            <Link to="/">
              <ChevronLeft className="h-4 w-4" />
              Back to Home
            </Link>
          </Button>
        </div>
        
        <div className="bg-white/80 backdrop-blur-sm p-8 rounded-xl shadow-lg">
          <h1 className="text-3xl font-bold text-primary mb-6">Terms of Service</h1>
          
          <div className="prose prose-blue max-w-none">
            <p className="mb-4">Last updated: {new Date().toLocaleDateString('en-US', {year: 'numeric', month: 'long', day: 'numeric'})}</p>
            
            <h2 className="text-xl font-semibold mt-6 mb-3">1. Acceptance of Terms</h2>
            <p>
              By accessing or using Shared Matter ("the Service"), you agree to be bound by these Terms of Service ("Terms"). If you disagree with any part of the terms, you do not have permission to access the Service.
            </p>
            
            <h2 className="text-xl font-semibold mt-6 mb-3">2. Description of Service</h2>
            <p>
              Shared Matter is an AI assistant application that provides various services including but not limited to conversation, memory storage, and integration with third-party services. The Service may change from time to time without prior notice.
            </p>
            
            <h2 className="text-xl font-semibold mt-6 mb-3">3. User Accounts</h2>
            <p>
              When you create an account with us, you must provide information that is accurate, complete, and current at all times. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account.
            </p>
            <p className="mt-2">
              You are responsible for safeguarding the password that you use to access the Service and for any activities or actions under your password.
            </p>
            
            <h2 className="text-xl font-semibold mt-6 mb-3">4. User Content</h2>
            <p>
              Our Service allows you to post, link, store, share and otherwise make available certain information, text, graphics, or other material ("Content"). You are responsible for the Content that you post to the Service, including its legality, reliability, and appropriateness.
            </p>
            <p className="mt-2">
              Your content is kept in a secured database and will only be shared with you, or others when requested by you.
            </p>
            
            <h2 className="text-xl font-semibold mt-6 mb-3">5. Intellectual Property</h2>
            <p>
              The Service and its original content (excluding Content provided by users), features, and functionality are and will remain the exclusive property of K2 Innoventions and its licensors. The Service is protected by copyright, trademark, and other laws of both the United States and foreign countries.
            </p>
            
            <h2 className="text-xl font-semibold mt-6 mb-3">6. Prohibited Uses</h2>
            <p>
              You agree not to use the Service:
            </p>
            <ul className="list-disc pl-6 my-4 space-y-2">
              <li>In any way that violates any applicable local, state, national, or international law or regulation.</li>
              <li>To transmit, or procure the sending of, any advertising or promotional material, including any "junk mail", "chain letter," or "spam."</li>
              <li>To impersonate or attempt to impersonate K2 Innoventions, a K2 Innoventions employee, another user, or any other person or entity.</li>
              <li>To engage in any other conduct that restricts or inhibits anyone's use or enjoyment of the Service, or which may harm K2 Innoventions or users of the Service.</li>
            </ul>
            
            <h2 className="text-xl font-semibold mt-6 mb-3">7. Limitation of Liability</h2>
            <p>
              In no event shall K2 Innoventions, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the Service.
            </p>
            
            <h2 className="text-xl font-semibold mt-6 mb-3">8. Termination</h2>
            <p>
              We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
            </p>
            
            <h2 className="text-xl font-semibold mt-6 mb-3">9. Changes to Terms</h2>
            <p>
              We reserve the right, at our sole discretion, to modify or replace these Terms at any time. By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms.
            </p>
            
            <h2 className="text-xl font-semibold mt-6 mb-3">10. Contact Information</h2>
            <p>
              If you have any questions about these Terms, please contact us at:
            </p>
            <p className="mt-2">
              K2 Innoventions<br />
              Email: legal@k2innoventions.com
            </p>
          </div>
        </div>
      </div>
      
      <footer className="w-full p-4 text-center text-sm text-foreground/70 bg-secondary/50 backdrop-blur-sm">
        &copy; {new Date().getFullYear()} K2 Innoventions | All Rights Reserved
      </footer>
    </div>
  );
};

export default TermsOfService;
